import {IMobilityState} from '.'
import {AsyncActionState} from '../../standard-actions/async-action'

export const HELP_BTN = 'Help'

export const initialState: Readonly<IMobilityState> = Object.freeze({
  summary: {
    status: AsyncActionState.NotStarted,
    data: {
      noOfPlans: 0,
      noOfDevices: 0,
    },
  },
  plans: {
    status: AsyncActionState.NotStarted,
    data: {
      plans: [],
    },
  },
  sharedplans: {
    status: AsyncActionState.NotStarted,
    data: {
      usageAllowance: [
        {
          isShared: '',
          allowanceType: '',
          trafficOrigin: '',
          trafficType: '',
          units: '',
          allocatedAllowance: 0,
          totalConsumption: 0,
          usedPercentage: 0,
          daysRemaining: 0,
          startDate: '',
          endDate: '',
        },
      ],
      memberCount: 0,
      queryCursor: '',
      members: [],
    },
  },
  individualplans: {
    status: AsyncActionState.NotStarted,
    data: {
      usageAllowance: [],
      eventTimeStamp: '',
      productsAvailable: [],
    },
  },
  serviceDetails: {
    status: AsyncActionState.NotStarted,
    data: {
      customerBAN: '',
      chargePointId: '',
      offerName: '',
      crmSource: '',
      billPeriodStartDate: '',
      billPeriodEndDate: '',
      pagingAndSorting: {
        pageSize: 0,
        pageIndex: 0,
        totalServicesCount: 0,
        totalPages: 0,
        sortKey: '',
        sortOrder: '',
        lastPage: '',
      },
      internationalDataUsage: {
        trafficOrigin: '',
        trafficType: '',
        units: '',
        totalConsumption: 0,
      },
      chargePointServices: [],
    },
  },
  serviceUsage: {
    status: AsyncActionState.NotStarted,
    data: {
      customerBAN: '',
      chargePointId: '',
      offerName: '',
      serviceId: '',
      servicePlan: '',
      serviceStatus: '',
      serviceSubscriptionId: '',
      serviceType: '',
      billPeriodStartDate: '',
      billPeriodEndDate: '',
      serviceUsageTableData: [],
      serviceUsageChartData: {
        units: '',
        PAST_USAGE: {
          data: [],
        },
        ACTIVE_DAY_PASS: {
          data: [],
        },
        ACTIVE_DATA_TOP_UP: {
          data: [],
        },
        PAY_AS_YOU_GO: {
          data: [],
        },
      },
    },
  },
  offerDetailsLegacy: {
    status: AsyncActionState.NotStarted,
    data: {
      crmSystem: '',
      billingSystem: '',
      customerSegment: '',
      cidn: '',
      customerBAN: '',
      isShared: false,
      isShaped: false,
      legacyIndicator: '',
      chargePointId: '',
      offerName: '',
      billPeriodStartDate: '',
      billPeriodEndDate: '',
      daysRemaining: '',
      pagingAndSorting: {
        pageSize: 0,
        pageIndex: 0,
        totalServicesCount: 0,
        totalPages: 0,
        sortKey: '',
        sortOrder: '',
        lastPage: '',
      },
      internationalDataUsage: {
        trafficOrigin: '',
        trafficType: '',
        units: '',
        totalConsumption: 0,
      },
      australianDataUsage: {
        trafficOrigin: '',
        trafficType: '',
        units: '',
        totalConsumption: 0,
        balanceAllowance: 0,
        totalDataAllowance: 0,
        totalSharedUsage: 0,
      },
      chargePointServices: [],
    },
  },
  mobileServicesList: {
    data: {
      serviceList: [],
      count: 0,
    },
    status: AsyncActionState.NotStarted,
  },
  mobileServicesData: {
    data: {
      serviceList: [],
      countOfServices: null,
    },
    status: AsyncActionState.NotStarted,
  },
  featureFlagsData: {
    data: {
      accessToDownloadAttachments: false,
      isStrategicUser: false,
      csc: false,
      mobServiceChange: false,
      viewAggregatedYPSpage: false,
    },
    status: AsyncActionState.NotStarted,
  },
  ypsProductFamiliesRequest: {
    data: null,
    status: AsyncActionState.NotStarted,
  },
  mobileServicesDetailStrategic: {
    data: {
      details: null,
      deviceConfig: null,
    },
    status: AsyncActionState.NotStarted,
  },
  strategicDeviceDetailsData: {
    data: {
      serviceNumber: null,
    },
    status: AsyncActionState.NotStarted,
  },
  strategicSimConfigInfoData: {
    data: {
      serviceInfo: null,
    },
    status: AsyncActionState.NotStarted,
  },
  userProfileDetails: {
    status: AsyncActionState.NotStarted,
    data: null,
  },
  covid19RequestFlag: false,
  tokens: {
    customerProfile: {
      status: AsyncActionState.NotStarted,
      data: {profile: '', active: false},
    },
  },
  updateNickNameData: {
    data: {
      message: '',
    },
    status: AsyncActionState.NotStarted,
  },
  viewNickNameData: {
    data: {
      nickName: '',
    },
    status: AsyncActionState.NotStarted,
  },
  createServiceRequest: {
    status: AsyncActionState.NotStarted,
  },
  requestCategoryItemQuestions: {
    items: [],
    status: AsyncActionState.NotStarted,
  },
  maximActivities: {
    data: {
      activities: [],
      totalCount: '',
      pagination: {
        pageIndex: 1,
        pageSize: 25,
        sortByOrder: '',
        sortBy: '',
      },
    },
    companyId: '',
    status: AsyncActionState.NotStarted,
  },
  directoryListing: {
    data: {
      directoryListingDetails: {
        listingLabel: '',
        description: '',
        status: '',
      },
    },
    status: AsyncActionState.NotStarted,
  },
  mobileServiceLegacyETC: {
    data: {
      totalEtcAmountIncludingGst: null,
      etcChargeDetails: null,
    },
    status: AsyncActionState.NotStarted,
  },
})
